export enum PricingCacheTagType {
  ComponentCategoryItems = 'ComponentCategoryItems',
  ComponentCategories = 'ComponentCategories',
}

export enum PricingTab {
  Base = 'base',
  Component = 'component',
  Adjustment = 'adjustment',
}
